import { Field, Modal, Text, ActionButton, Autocomplete, TextField } from "components/commons";
import React from "react";
import locale from "localization";
import useForm from "hooks/useForm.v2";
import { sendStationEmail } from "apis/account-stations";
import { useApi, useMount } from "hooks";
import PlatformType from "enums/platform-type";
import { prettifyPlatformType } from "utils/pretty.utils";
import { activateModalState } from "./activation-modal.state";
import StationType from "enums/station-type";

const SendActivationModal = ({ stationName, stationType, refresh, stationId, ...modal }) => {
  const form = useForm(activateModalState);
  const { fields, initializeForm } = form;
  const { emailTemplate = {}, testFuelCode = {} } = fields;

  let options = [PlatformType.PLC, PlatformType.PLB, PlatformType.PLCandPLB, PlatformType.VIP];

  if (
    [
      StationType.XDODO,
      StationType.XWIDO,
      StationType.XDODO_W,
      StationType.XWIDO_W,
      StationType.UDODOX,
      StationType.CODOL,
      StationType.UWIDOX,
    ].includes(stationType)
  ) {
    options = [PlatformType.VIP];
  }

  const sendStationEmailRequest = useApi({
    api: sendStationEmail,
    handleOwnError: {
      badrequest: true,
    },
  });

  const { loading } = sendStationEmailRequest;

  useMount(() => {
    initializeForm({}, true);
  });

  return (
    <Modal
      {...modal}
      title={locale.askSendActivationEmail}
      style={{
        width: "600px",
      }}
    >
      <Text className="text-center">
        <locale.Populate
          text={locale.youAreAboutToSendActivationEmailTo}
          items={[<b>{stationName}</b>]}
        />
      </Text>

      <Field
        childrenStyle={{
          minWidth: "400px",
          maxWidth: "400px",
        }}
        {...emailTemplate}
      >
        <Autocomplete
          {...emailTemplate}
          options={options.map((platform) => ({
            value: platform,
            label: prettifyPlatformType(platform),
          }))}
        />
      </Field>
      {[PlatformType.PLB, PlatformType.PLCandPLB].includes(emailTemplate.value) && (
        <Field
          childrenStyle={{
            minWidth: "400px",
            maxWidth: "400px",
          }}
          {...testFuelCode}
        >
          <TextField
            {...testFuelCode}
            onChange={(name, { value }) => {
              testFuelCode.onChange(name, { value, errorType: "" });
            }}
          />
        </Field>
      )}

      <ActionButton
        right
        items={[
          {
            text: locale.cancel,
            onClick: () => {
              modal.close();
              initializeForm({}, true);
            },
          },
          {
            text: locale.yesSendActivationEmail,
            disabled: !form.isFormSubmittable,
            loading: loading,
            onClick: () => {
              form.onSubmit(async ({ emailTemplate, testFuelCode: code }) => {
                try {
                  await sendStationEmailRequest.request({
                    stationId,
                    emailTemplate,
                    testFuelCode: code,
                  });
                  modal.close();
                  initializeForm({}, true);
                  refresh();
                } catch (e) {
                  const { errorCode } = e?.data || {};
                  const errors = {
                    S1013: () => {
                      testFuelCode?.onChange(testFuelCode.name, {
                        value: code,
                        errorType: "invalid-code",
                      });
                    },
                  };
                  if (errors[errorCode]) {
                    errors[errorCode]();
                  } else {
                    e.showError();
                  }
                }
              });
            },
          },
        ]}
      />
    </Modal>
  );
};

export default SendActivationModal;
